document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('[data-frete-target]');
  if (!targets.length) return;

  const ENDPOINT = window.ALLPOST_ENDPOINT || '';
  const DEBUG = window.FRETE_DEBUG === true;

  const cache = new Map();

  function log(...args) {
    if (DEBUG) console.log('[FRETE]', ...args);
  }

  function sanitizeCep(cep) {
    return String(cep || '').replace(/\D/g, '');
  }

  function formatCep(cep) {
    const c = sanitizeCep(cep);
    return c.length === 8 ? c.replace(/(\d{5})(\d{3})/, '$1-$2') : '';
  }

  function getCep() {
    return sanitizeCep(localStorage.getItem('cliente_cep'));
  }

  /*
  // TRECHO ANTIGO SUBSTITUÍDO
  function formatDate(dateString) {
    if (!dateString) return null;
    const d = new Date(dateString);
    if (isNaN(d)) return null;

    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit'
    }).format(d);
  }
  */

  // NOVO: normaliza a data para evitar problema de timezone
  function parseDate(dateString) {
    if (!dateString) return null;

    const normalized = String(dateString).length === 10
      ? `${dateString}T12:00:00`
      : dateString;

    const d = new Date(normalized);

    if (isNaN(d.getTime())) return null;

    return startOfDay(d);
  }

  // NOVO: zera hora/min/seg para comparações consistentes
  function startOfDay(date) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  // NOVO: diferença em dias corridos entre duas datas
  function diffInDays(start, end) {
    const msPerDay = 24 * 60 * 60 * 1000;
    return Math.round((startOfDay(end) - startOfDay(start)) / msPerDay);
  }

  // NOVO: soma dias úteis, ignorando sábado e domingo
  function addBusinessDays(startDate, days) {
    const date = new Date(startDate);
    let added = 0;

    while (added < days) {
      date.setDate(date.getDate() + 1);

      const day = date.getDay();
      const isWeekend = day === 0 || day === 6;

      if (!isWeekend) {
        added++;
      }
    }

    return startOfDay(date);
  }

  // NOVO: formata apenas o dia da semana
  function formatWeekday(date) {
    return new Intl.DateTimeFormat('pt-BR', {
      weekday: 'long'
    }).format(date).toLowerCase();
  }

  // NOVO: formata dia e mês por extenso
  function formatDayMonth(date) {
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit'
    }).format(date).toLowerCase();
  }

  function isSameDate(a, b) {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
  }

  function getNextOccurrenceOfWeekday(baseDate, targetWeekday) {
    const base = startOfDay(baseDate);
    const result = new Date(base);

    let diff = targetWeekday - base.getDay();

    if (diff <= 0) {
      diff += 7;
    }

    result.setDate(result.getDate() + diff);
    return startOfDay(result);
  }

  // NOVO: monta a mensagem final conforme as regras de negócio
  function buildDeliveryMessage(today, deliveryDate, originalCalendarDiff) {
    const deliveryWeekday = deliveryDate.getDay();

    const lightningIcon = originalCalendarDiff <= 3
      ? ` <span class="delivery-lightning" aria-label="fullfilment">
          <svg viewBox="0 0 24 24" role="img" focusable="false">
            <path d="M13 2L6 14h5l-1 8 8-12h-5l0-8z"></path>
          </svg>
        </span>`
      : '';

    // Entrega em 24h
    if (originalCalendarDiff === 1) {
      return `${lightningIcon} Chegará amanhã`;
    }

    // Próxima ocorrência imediata do mesmo dia da semana
    const nextImmediateWeekday = getNextOccurrenceOfWeekday(today, deliveryWeekday);

    // Se a entrega cair exatamente na próxima ocorrência daquele dia da semana,
    // mostramos só o dia da semana.
    if (isSameDate(deliveryDate, nextImmediateWeekday)) {
      return `${lightningIcon} Chegará até ${formatWeekday(deliveryDate)}`;
    }

    // Se não for a próxima ocorrência imediata, mostramos também a data
    // para evitar ambiguidade.
    return `${lightningIcon} Chegará até ${formatWeekday(deliveryDate)}, ${formatDayMonth(deliveryDate)}`;
  }

  function getCacheKey(target, cep) {
    const sku = target.dataset.sku || '';
    return `${sku}_${cep}`;
  }

  function buildPayload(target, cep) {
    const sku = target.dataset.sku;
    if (!sku) return null;

    return {
      rate: {
        origin: {
          country: 'BR',
          postal_code: '01001-000',
          province: 'SP',
          city: 'São Paulo',
          name: null,
          address1: 'Rua Teste',
          address2: '',
          address3: null,
          phone: null,
          fax: null,
          email: null
        },
        destination: {
          country: 'BR',
          postal_code: formatCep(cep),
          province: '',
          city: '',
          name: 'Cliente',
          address1: '',
          address2: '',
          address3: null,
          phone: null,
          fax: null,
          email: null
        },
        items: [
          {
            name: target.dataset.productName,
            sku: sku,
            quantity: 1,
            grams: Number(target.dataset.grams || 0),
            price: Number(target.dataset.price || 0),
            vendor: target.dataset.vendor
          }
        ],
        currency: 'BRL',
        locale: 'pt-BR'
      }
    };
  }

  async function fetchFrete(payload) {
    log('Payload enviado:', payload);

    const res = await fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const text = await res.text();

    log('Status:', res.status);
    log('Resposta bruta:', text);

    let data = null;

    try {
      data = text ? JSON.parse(text) : null;
    } catch (e) {
      log('Erro parse JSON');
    }

    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }

    return data;
  }

  /*
  // TRECHO ANTIGO SUBSTITUÍDO
  function render(target, rate) {
    if (!rate) {
      target.textContent = 'Sem prazo';
      return;
    }

    const min = formatDate(rate.min_delivery_date);
    const max = formatDate(rate.max_delivery_date);

    if (min && max) {
      target.textContent = `Chegará entre ${min} e ${max}`;
    } else if (min) {
      target.textContent = `Chegará até ${min}`;
    } else {
      target.textContent = 'Prazo no checkout';
    }
  }
  */

  // NOVO: usa apenas min_delivery_date e recalcula a exibição em dias úteis
  function render(target, rate) {
    if (!rate || !rate.min_delivery_date) {
      target.textContent = 'Sem prazo';
      return;
    }

    const quotedMinDate = parseDate(rate.min_delivery_date);

    if (!quotedMinDate) {
      target.textContent = 'Prazo no checkout';
      return;
    }

    const today = startOfDay(new Date());

    // Diferença original em dias corridos vinda da cotação
    const calendarDiff = diffInDays(today, quotedMinDate);

    // Proteção para não trabalhar com valores negativos
    const safeCalendarDiff = Math.max(calendarDiff, 0);

    // Recalcula visualmente a data final em dias úteis, ignorando sábado e domingo
    const businessMinDate = addBusinessDays(today, safeCalendarDiff);

    // IMPORTANTE:
    // - sempre mostra o dia da semana
    // - se conflitar com o dia da semana atual, mostra também dia e mês
    // - se for 24h, mostra "Chegará amanhã"
    target.innerHTML = buildDeliveryMessage(today, businessMinDate, safeCalendarDiff);
  }

  function renderError(target, error) {
    target.textContent = 'Erro frete';
    log('Erro:', error);
  }

  function renderLoading(target) {
    target.textContent = 'Consultando...';
  }

  async function update(target, cep) {
    if (!ENDPOINT) {
      target.textContent = 'Sem endpoint';
      return;
    }

    if (!cep || cep.length !== 8) {
      target.textContent = 'Informe seu CEP';
      return;
    }

    const key = getCacheKey(target, cep);

    if (cache.has(key)) {
      log('CACHE HIT:', key);
      const data = await cache.get(key);
      render(target, data?.rates?.[0]);
      return;
    }

    log('CACHE MISS:', key);

    const payload = buildPayload(target, cep);

    if (!payload) {
      target.textContent = 'Sem SKU';
      return;
    }

    renderLoading(target);

    const promise = fetchFrete(payload)
      .catch(err => {
        cache.delete(key);
        throw err;
      });

    cache.set(key, promise);

    try {
      const data = await promise;
      render(target, data?.rates?.[0]);
    } catch (e) {
      renderError(target, e);
    }
  }

  function run() {
    const cep = getCep();
    targets.forEach(t => update(t, cep));
  }

  run();

  document.addEventListener('cepAtualizado', () => {
    cache.clear();
    run();
  });
});